import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox as CheckboxComp } from 'material-ui';

const Checkbox = function Checkbox(props) {
  const {
    label,
    onChange,
    checked,
  } = props;
  return (
    <div className="icheckbox_md_wrapper">
      <CheckboxComp
        label={label}
        checked={checked}
        onCheck={onChange}
      />
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

Checkbox.defaultProps = {
  label: '-- NOT SET --',
  onChange: (evt, isInputChecked) => console.log(evt, isInputChecked),
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.js